const TOGGLE_REFRESH = 'TOGGLE_REFRESH'

const refreshReducer = (state = false, action) => {
  switch (action.type) {
    case TOGGLE_REFRESH:
      return !state
    default:
      return state
  }
}

export const toggleRefresh = () => ({
  type: TOGGLE_REFRESH,
})

export default refreshReducer
